
import React, { Component, useEffect, useState } from "react";
import { Row, Col, Alert, Button, Container, Label } from "reactstrap";

// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// action
import { forgetUser } from '../../store/actions';

// import images
import logodark from "../../assets/images/logo-dark.png";

import { Carousel } from "react-bootstrap";

// import the use-http
import useHttp from '../../hook/use-http';

const ResetPassword = ({ forgetUser, message, history, match }) => {

    //this variable will be used to send email to user
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmationCode, setConfirmationCode] = useState('');

    // this variable will be used to control de error 
    const [resetError, setResetError] = useState(null);
    const [messageResetPassword, setMessageResetPassword] = useState(null);


    // this function will be used to request the server to login the user
    const { loading, error, request } = useHttp();

    useEffect(() => {

        // get the email form url
        const { email } = match.params;
        // then set the email to the state variable
        setUsername(email);

    }, [])

    // this function will be used to process the data response from server
    const handleForgetPasswordDataResponse = (response) => {

        if (response === true) {
            setResetError(false);
            setMessageResetPassword('Password reset successfully');
        } else {
            setResetError(true);
            setMessageResetPassword(response.message);
        }
    }

    // handleValidSubmit
    const handleResetPassword = (event, values) => {
        try {

            // set the header of the request
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            request({
                url: `/noauth/user/confirmForgotPassword`,
                method: 'POST',
                headers: myHeaders,
                body: {
                    email: username,
                    password: password,
                    confirmationCode: confirmationCode
                }
            }, handleForgetPasswordDataResponse)

        } catch (error) {
            console.log(error);
        }
    }

    return (
        <React.Fragment>
            <div>
                <Container fluid className="p-0">
                    <Row className="g-0">
                        <Col lg={4}>
                            <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                                <div className="w-100">
                                    <Row className="justify-content-center">
                                        <Col lg={9}>
                                            <div>
                                                <div className="text-center">
                                                    <div>
                                                        <Link to="/" className="logo"><img src={require("../../assets/images/lexmark/lxk-logo-2x.svg")} height="20" alt="logo" /></Link>
                                                    </div>

                                                    <h4 className="font-size-16">Restablecer la contraseña</h4>
                                                    <p className="text-muted font-size-13">Por favor ingrese su nueva contraseña y el codigo de confirmación enviado a su correo electronico.</p>
                                                </div>

                                                <div className="p-2 mt-2">

                                                    {resetError === true && < Alert color="danger">{messageResetPassword}</Alert>}
                                                    {resetError === false && < Alert color="success">{messageResetPassword}</Alert>}

                                                    <AvForm className="form-horizontal" onValidSubmit={handleResetPassword}>

                                                        <div className="auth-form-group-custom mb-4">
                                                            <i className="ri-mail-line auti-custom-input-icon" style={{ color: '#008945' }}></i>
                                                            <Label htmlFor="useremail">Email</Label>
                                                            <AvField
                                                                name="useremail"
                                                                value={username}
                                                                type="email"
                                                                validate={{ email: true, required: true }}
                                                                className="form-control"
                                                                id="useremail"
                                                                placeholder="Ingrese correo electrónico"
                                                                onChange={(e) => setUsername(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="auth-form-group-custom mb-4">
                                                            <i className="ri-lock-2-line auti-custom-input-icon" style={{ color: '#008945' }}></i>
                                                            <Label htmlFor="userpassword">Nueva Contraseña</Label>
                                                            <AvField
                                                                name="password"
                                                                value={password}
                                                                type="password"
                                                                validate={{
                                                                    required: true,
                                                                    minLength: { value: 8, errorMessage: 'La contraseña debe tener al menos 8 caracteres' },
                                                                    maxLength: { value: 20, errorMessage: 'La contraseña no debe tener mas de 20 caracteres' },
                                                                    pattern: { value: '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*.])(?=.{8,}).*$', errorMessage: 'La contraseña debe tener al menos una mayuscula, una minuscula, un numero y un caracter especial' }
                                                                }}
                                                                className="form-control"
                                                                id="userpassword"
                                                                placeholder="Ingrese nueva contraseña"
                                                                onChange={(e) => setPassword(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="auth-form-group-custom mb-4">
                                                            <i className="ri-code-line auti-custom-input-icon" style={{ color: '#008945' }}></i>
                                                            <Label htmlFor="usercode">Codigo de Confirmacion</Label>
                                                            <AvField
                                                                name="usercode"
                                                                value={confirmationCode}
                                                                type="text"
                                                                validate={{
                                                                    required: true,
                                                                    minLength: { value: 4, errorMessage: 'El codigo de confirmacion debe tener al menos 4 caracteres' },
                                                                }}
                                                                className="form-control"
                                                                id="useremail"
                                                                placeholder="Ingrese codigo de confirmacion"
                                                                onChange={(e) => setConfirmationCode(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="mt-4 text-center">
                                                            <Button color="primary" className="w-md waves-effect waves-light btn btn-primary-lexmark" type="submit">Reiniciar</Button>
                                                        </div>
                                                    </AvForm>
                                                </div>

                                                <div className="mt-3 text-center">
                                                    {/* 
                                                        <p>Don't have an account ? <Link to="/register" className="fw-medium text-primary"> Register </Link> </p>
                                                        */}
                                                    <div className="container d-flex flex-column justify-content-center align-items-center">
                                                        <ul className="legal-menu-brand">
                                                            <li className="legal-menu-brand-logo"><img
                                                                src={require("../../assets/images/lexmark/lxk-symbol-2x.svg")}
                                                                alt="Símbolo de Lexmark" />
                                                            </li>
                                                            <li>
                                                                <ul className="legal-menu-brand-copyright">
                                                                    <li>Lexmark International, Inc.</li>
                                                                    <li>&copy;2022 All rights reserved.</li>

                                                                </ul>
                                                            </li>
                                                        </ul>
                                                        <ul className="legal-menu-notice mt-2" >
                                                            <li><a href="/es_xl/privacy-policy.html">Política de privacidad</a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col >
                        <Col lg={8}>
                            <Carousel>
                                {/** 
                                <Carousel.Item interval={30000} >
                                    <img
                                        className="d-block w-100 authentication-bg"
                                        src="../assets/lexmark_principal/1.jpg"
                                        alt="Second slide"
                                    />

                                </Carousel.Item>
                                <Carousel.Item interval={30000}>
                                    <img
                                        className="d-block w-100 authentication-bg"
                                        src="../assets/lexmark_principal/2.jpg"
                                        alt="Second slide"
                                    />

                                </Carousel.Item>
                                <Carousel.Item interval={30000}>

                                    <img
                                        className="d-block w-100 authentication-bg"
                                        src="../assets/lexmark_principal/3.jpg"
                                        alt="Second slide"
                                    />

                                </Carousel.Item>
                                */}
                                <Carousel.Item interval={30000}>

                                    <img
                                        className="d-block w-100 authentication-bg"
                                        src="../assets/lexmark_principal/4.jpg"
                                        alt="Second slide"
                                    />

                                </Carousel.Item>

                            </Carousel>
                        </Col>
                    </Row >
                </Container >
            </div >
        </React.Fragment >
    );

}

const mapStatetoProps = state => {
    const { message, forgetError, loading } = state.Forget;
    return { message, forgetError, loading };
}

export default withRouter(
    connect(mapStatetoProps, { forgetUser })(ResetPassword)
);